exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._30nSR1pkzjiIOECcluinT_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._30nSR1pkzjiIOECcluinT_ ._3UXbpEUD1yD8KE97uUiyo0{font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._30nSR1pkzjiIOECcluinT_ ._3UXbpEUD1yD8KE97uUiyo0{margin-top:8px}", ""]);

// exports
exports.locals = {
	"container": "_30nSR1pkzjiIOECcluinT_",
	"text": "_3UXbpEUD1yD8KE97uUiyo0"
};